// extracted by mini-css-extract-plugin
export default {"container":"PermissionSectionView_container__Vrtu9","permissionsViewList":"PermissionSectionView_permissionsViewList__co4G4"};